// extracted by mini-css-extract-plugin
module.exports = {"lightTheme":"nvrt-light_theme","darkTheme":"nvrt-dark_theme"};